export default __webpack_public_path__ + "static/media/environment.c22926de.png";